

import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, catchError, retry } from 'rxjs';
import { ErrorService } from '../services/error.service';


@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(public errorService: ErrorService, ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error && error.error ) {
         this.errorService.setError(error.error.message);
       } else {
          this.errorService.setError(error.message);
       }
       return throwError(() => error);

        // }
      })
    );
  }

}
